import { isObject } from "../../../../../utils/mappersUtils/guards";
import {
  getArray,
  getBoolean,
  getNumber,
  getString,
} from "../../../../../utils/mappersUtils/object";

export function mapDiagnosticFlow(flow) {
  if (!isObject(flow)) return null;

  return {
    id: getNumber(flow, "id"),
    name: getString(flow, "name"),
    information: getString(flow, "information"),
    isActive: getBoolean(flow, "isActive", true),
  };
}

export function mapDiagnosticFlows(flows) {
  if (!Array.isArray(flows)) return [];
  return flows.map(mapDiagnosticFlow).filter(Boolean);
}

// GET by id: the flow definition plus the nullable dealerInfo block.
export function mapDiagnosticFlowDetail(flow) {
  if (!isObject(flow)) return null;

  return {
    id: getNumber(flow, "id"),
    name: getString(flow, "name"),
    information: getString(flow, "information"),
    isActive: getBoolean(flow, "isActive", true),
    flowchartImage: getString(flow, "flowchartImage") || null,
    jsonFlow: getString(flow, "jsonFlow"),
    dealerInfo: {
      dealerGroupId: getNumber(flow, "dealerInfo.dealerGroupId"),
      isDefaultForWarranty: getBoolean(flow, "dealerInfo.isDefaultForWarranty", false),
      laborCodes: getString(flow, "dealerInfo.laborCodes"),
      outletIds: getArray(flow, "dealerInfo.outletIds"),
      brandIds: getArray(flow, "dealerInfo.brandIds"),
    },
  };
}
